import { BRAND_TYPE_KEIVI } from "../../utils/constant";
import { createDomain, updateDomain } from "../api/retail/domainApi";

export function getStatusDomain(statusNumber?: number, domain?: string) {
  if (!domain) return "notUse";
  // hass
  return "success";
  // if (statusNumber === 3) return "success";
  // if (statusNumber === undefined) return "error";
  // if ([0, 1, 2].includes(statusNumber)) return "processing";
  // return "error";
}

export async function createOrUpdateDomain(
  platform: string,
  newDomain: string,
  retailerId: string,
  oldDomain?: string
) {
  if (!oldDomain) {
    return createDomain(platform, newDomain, retailerId);
  } else {
    return updateDomain(platform, newDomain, retailerId, oldDomain);
  }
}

export function getDomain(domain?: string, statusDomain?: number, brandType?: string) {
  let defaultDomain = process.env.REACT_APP_THEME_IFRAME;
  // hass
  // if (!domain || statusDomain !== 3 || process.env.NODE_ENV !== "production") {
  //   return defaultDomain;
  // }
  if (brandType === BRAND_TYPE_KEIVI) {
    defaultDomain = process.env.REACT_APP_THEME_IFRAME_KEIVI;
  }
  if (!domain) {
    return defaultDomain;
  }
  return `https://${domain}`
}

export function getNamespace(
  merchantInfo: IRetailMerchantInfo | undefined,
  branchInfo: IRetailBranchInfo | undefined
) {
  let namespace = "";

  //short link
  if (merchantInfo && branchInfo) {
    // namespace = `${merchantInfo?.ref_id}-${branchInfo?.ref_id}`;
    namespace = `${merchantInfo?.id}/${branchInfo?.id}/_all`;
  }

  return namespace;
}

export function removeHttps(url: string) {
  return url.replace("https://", "");
}

export function getWebsiteUrl(
  platform: string,
  namespace: string,
  domainConfig?: string,
  statusDomain?: number,
  brandType?: string,
) {
  const domain = getDomain(domainConfig, statusDomain, brandType);
  if (domain && domain !== process.env.REACT_APP_THEME_IFRAME) {
    return domain;
  }
  return `${domain}/${platform}/${namespace}`;
}

export function getKVWebDomain(merchantInfo?: {
  ref_code?: string;
  domain?: string;
  domain_status?: number;
  is_keivi_region?: boolean;
}) {
  if (merchantInfo?.domain) {
    return merchantInfo?.domain;
  }
  if (!merchantInfo?.ref_code) return "";
  return `${merchantInfo?.ref_code}.${!!merchantInfo?.is_keivi_region ? process.env.REACT_APP_KEIVIWEB_DOMAIN : process.env.REACT_APP_KIOTVIETWEB_DOMAIN}`;
}

export function getKVWebUrlByDomain(domain?: string) {
  if (!domain) return "";
  return `https://${domain}`;
}

export function getKVWebUrl(merchantInfo?: {
  ref_code?: string;
  domain?: string;
  domain_status?: number;
}) {
  const domain = getKVWebDomain(merchantInfo);
  return getKVWebUrlByDomain(domain);
}
